module.exports = __webpack_public_path__ + "img/active-b.33c51f24.png";